import React from 'react';
import { Box, Grid, Typography, useTheme, alpha } from '@mui/material';

interface FieldGroupProps {
  title: string;
  children: React.ReactNode;
}

/**
 * Always-open titled fieldset for a cluster of ATLAS form fields. Visual treatment is identical
 * to the original cross-border means-of-transport block it generalises.
 */
export const FieldGroup: React.FC<FieldGroupProps> = ({ title, children }) => {
  const theme = useTheme();
  return (
    <Box
      component="fieldset"
      sx={{
        border: '1px solid',
        borderColor: alpha(theme.palette.primary.main, 0.3),
        borderRadius: 2,
        p: 0,
        m: 0,
        mb: 2,
        pt: 1,
      }}
    >
      <Box
        component="legend"
        sx={{ ml: 1.5, px: 0.75, display: 'flex', alignItems: 'center', gap: 0.5, lineHeight: 1 }}
      >
        <Typography
          variant="caption"
          sx={{ fontWeight: 600, fontSize: '0.78rem', color: theme.palette.text.primary }}
        >
          {title}
        </Typography>
      </Box>
      <Box sx={{ p: 1.5, pt: 0.5 }}>
        <Grid container spacing={0.5}>
          {children}
        </Grid>
      </Box>
    </Box>
  );
};
